import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import type { InAppBrowserRef } from '@freelancer/in-app-browser';
import { InAppBrowser } from '@freelancer/in-app-browser';
import { Pwa } from '@freelancer/pwa';

@Injectable({
  providedIn: 'root',
})
export class VideoVerificationService {
  private browser: InAppBrowserRef;

  constructor(
    private inAppBrowser: InAppBrowser,
    private pwa: Pwa,
    private router: Router,
  ) {}

  openVideoVerification(id: number): void {
    const url = `/verification/video/${id}`;
    const withdrawalUrl = `/payments/withdraw.php`;
    if (this.shouldOpenInApp()) {
      this.browser = this.inAppBrowser.open(url);
      this.browser.closeOnNavigation(withdrawalUrl);
      this.browser.onExit().then(() => {
        this.router.navigate([withdrawalUrl]);
      });
    } else {
      this.router.navigate([url]);
    }
  }

  shouldOpenInApp(): boolean {
    return this.pwa.isNative() && this.pwa.getPlatform() === 'ios';
  }
}
